import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "nas-remote__menu-title"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]

import { PropType } from 'vue'
import { usePromisifyDialog } from '@shared/utils/dialog'
import PopWrapper from '@remote/components/PopWrapper.vue'
import { vibrate } from '@remote/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  options: {
    type: Array as PropType<string[]>,
    required: true,
  },
  /**
   * 需要标记为危险的选项的下标。
   * [0] 就是第一个选项需要标记为危险。
   */
  danger: {
    type: Array as PropType<number[]>,
    default: () => ([]),
  },
  themeClass: {
    type: String,
    default: 'is-dark',
  },
},
  emits: ["dialog-close"],
  setup(__props, { emit }: { emit: ({
  (e: 'dialog-close', item?: string): void
}), expose: any, slots: any, attrs: any }) {





const { close, isShow } = usePromisifyDialog(emit)

const handleClose = (option?: string) => {
  vibrate([10])
  close(option)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopWrapper, {
    close: handleClose,
    "is-show": _unref(isShow)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['nas-remote__menu', __props.themeClass]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [
        (__props.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("p", null, _toDisplayString(__props.title), 1),
              (__props.description)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.description), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({
          'nas-remote__menu-option': true,
          'is-danger': __props.danger.includes(index)
        }),
            key: item,
            onClick: ($event: any) => (handleClose(item))
          }, _toDisplayString(item), 11, _hoisted_3))
        }), 128))
      ], 2)
    ]),
    _: 1
  }, 8, ["is-show"]))
}
}

})